import React from 'react';
import { Modal, Button } from '@company-mrv/mrv-design-system/components';
import './modalComBotaoFechar.css'

const ModalComBotaoFechar = (props: any) => 
{
    return (
        <Modal {...props}>
            <Modal.Content className="modal-content">
                <Button size="small" variant="text" color="neutral" className="botao-fechar-modal" onClick={props.aoClicarBotaoFecharModal}>X</Button>
                { props.children }
            </Modal.Content>
        </Modal>
    );
}

export default ModalComBotaoFechar;